import React from 'react'
import Newsletter from './NewsLetter'
import GetInTouch from './GetInTouch'
import Footer from './Footer'
import PartnerTop from './PartnerTop'
import IMS1 from '../assets/IMS-1.png'
import ProductDes from './ProductDes'
import Productsdiv3 from './Productsdiv3'
import FeaturesGrid from './FeaturesGrid'
import icon1 from '../assets/marketing.png';
import icon2 from '../assets/operation.png';
import icon3 from '../assets/finance.png';
import icon4 from '../assets/automation.png';
import MainFeatures from './MainFeatures'
import mf1 from '../assets/enquiry.png';
import mf2 from '../assets/enquiry-follow-up.png';
import mf3 from '../assets/admission.png';
import mf4 from '../assets/fees-management.png';
import mf5 from '../assets/employ-and-user-manage.png';
import mf6 from '../assets/students-attendance.png';
import mf7 from '../assets/employee-attendance.png';
import mf8 from '../assets/course-tracker.png';
import mf9 from '../assets/study-material-upload.png';
import mf10 from '../assets/mass-lead-upload.png';
import mf11 from '../assets/one-stop-dashboard.png';
import mf12 from '../assets/mis-reports.png';
import mf13 from '../assets/process-automation.png';
import mf14 from '../assets/automated-sms.png';
import mf15 from '../assets/basic-accounting.png';
import mf16 from '../assets/basic-utilities.png';
import product1 from '../assets/product1.png';
import Package from './Package'
import { isDisabled } from '@testing-library/user-event/dist/utils'


const InstituteManagement = () => {
    return (
        <div>
            <PartnerTop largeHeading="WARALS Institute Management System" smallHeading="WIMS for all kind of institutes and training organization." image={IMS1} />
            <ProductDes largeHeading="WARALS Institute Management Systems" para1=" WIMS is like a Mini-ERP for all kind of institutes and training
                organizations. WIMS is designed to reduce operational complexity and
                help to achieve the core goal of revenue generation of any
                Institutes/Training organizations. WIMS, as a specialized product is a
                result of collaborative efforts by our architects and end-users by
                getting the business requirements and aligning the flow according to
                them." para2=" We have developed all the required functions which can help to achieve
                the desired result with minimal effort and fewer resources and not to
                mention with easy to use interface."/>

            <Productsdiv3 largeHeading="Why WIMS is Unique in Offerings" lightHeading="It is hard to find full-featured offering specific to Institute and Training Organizations which can cover all aspects of a business. It reduces the pain of maintaining different department on the various application and makes life easy of entrepreneurs." imagesrc= {product1}/>

            <FeaturesGrid
                features={[
                    {
                        id: 1,
                        title: "MARKETING & SALES",
                        description:
                            "Leads Management, Inquiry Follow-ups, Email/SMS Integration for Inquiry Follow-ups, Admissions",
                        icon: icon1,
                    },
                    {
                        id: 2,
                        title: "OPERATIONS",
                        description:
                            "Batch Scheduling, Trainers/Students/Employees Management, Course Tracker, Attendance",
                        icon: icon2,
                    },
                    {
                        id: 3,
                        title: "FINANCE",
                        description:
                            "Fee management and Reminders, Expense Management, Employee Salaries, Financials reports",
                        icon: icon3,
                    },
                    {
                        id: 4,
                        title: "AUTOMATION",
                        description:
                            "Email and SMS Panel Integration, Auto Assignment of Leads, Auto Email of Reports",
                        icon: icon4,
                    },
                ]}
            />

            <MainFeatures features={[
                {
                    title: 'Enquiry Module',
                    description: 'Entry of Leads details and management',
                    icon: mf1
                },
                {
                    title: 'Enquiry Follow Up',
                    description: 'No Missed Follow ups for more conversions',
                    icon: mf2
                },
                {
                    title: 'Admissions',
                    description: 'Admissions conversion directly from Enquiry',
                    icon: mf3
                },
                {
                    title: 'Fees Management',
                    description: 'Fees Generation, receipt with installment option',
                    icon: mf4
                },

                {
                    title: 'Employee and Users Management',
                    description: 'Role based access for employee/users',
                    icon: mf5
                },
                {
                    title: 'Students Attendance',
                    description: 'Batch wise Students assignment and attendance',
                    icon: mf6
                },
                {
                    title: 'Employee Attendance',
                    description: 'Track Time, Build Trust. Smart Attendance, Smarter Workforce',
                    icon: mf7
                },
                {
                    title: 'Course Tracker',
                    description: 'Module wise Course tracker for better scheduling',
                    icon: mf8
                },
                {
                    title: 'Study Material Upload',
                    description: 'Option of uploading Course materials for students',
                    icon: mf9
                },
                {
                    title: 'Mass Lead Upload',
                    description: 'Admin can upload leads in bulk through excel for time savings',
                    icon: mf10
                },
                {
                    title: 'One Stop Dashboard',
                    description: 'Informative Dashboard for management decision-making',
                    icon: mf11
                },
                {
                    title: 'MIS reports',
                    description: 'Various MIS reports exportable in Excel and PDF format',
                    icon: mf12
                },
                {
                    title: 'Process Automation',
                    description: 'Automatic Lead assignment, SMS reminders',
                    icon: mf13
                },
                {
                    title: 'Automated SMS/Emails',
                    description: 'SMS/Email Configuration and Whatsaap API Integration',
                    icon: mf14
                },
                {
                    title: 'Basic Accounting',
                    description: 'Basic Accounting feature for Profit/Loss and Balance Sheet',
                    icon: mf15
                },
                {
                    title: 'Backup Utilities',
                    description: 'Backup Utilities for database backup and restore',
                    icon: mf16
                }


            ]} />

            <Package
                packages={[
                    {
                        title: 'Free*',
                        buttonText: '*Get A Demo Account',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload' },
                            { label: 'Student Attendance' },
                            { label: 'Employee Attendance' },
                            { label: 'Study Material Upload' },
                            { label: 'Course Tracker' },
                            { label: 'Utilities - Database Backup' },
                            { label: 'Student Panel' },
                            { label: 'Student Transfer' },
                            { label: 'Basic Accounting Features' }
                        ]
                    },
                    {
                        title: 'Basic',
                        buttonText: 'Get A Quote',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload', isDisabled:true},
                            { label: 'Student Attendance', isDisabled:true },
                            { label: 'Employee Attendance', isDisabled:true },
                            { label: 'Study Material Upload', isDisabled:true },
                            { label: 'Course Tracker', isDisabled:true },
                            { label: 'Utilities - Database Backup', isDisabled:true },
                            { label: 'Student Panel', isDisabled:true },
                            { label: 'Student Transfer', isDisabled:true },
                            { label: 'Basic Accounting Features', isDisabled:true }
                        ]
                    },
                    {
                        title: 'Medium',
                        buttonText: 'Get A Quote',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload' },
                            { label: 'Student Attendance' },
                            { label: 'Employee Attendance' },
                            { label: 'Study Material Upload' },
                            { label: 'Course Tracker' },
                            { label: 'Utilities - Database Backup' },
                            { label: 'Student Panel', isDisabled:true },
                            { label: 'Student Transfer', isDisabled:true },
                            { label: 'Basic Accounting Features', isDisabled:true }
                        ]
                    },
                    {
                        title: 'Advance',
                        buttonText: 'Get A Quote',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload' },
                            { label: 'Student Attendance' },
                            { label: 'Employee Attendance' },
                            { label: 'Study Material Upload' },
                            { label: 'Course Tracker' },
                            { label: 'Utilities - Database Backup' },
                            { label: 'Student Panel' },
                            { label: 'Student Transfer' },
                            { label: 'Basic Accounting Features' }
                        ]
                    },
                   
                ]}
            />


            {/* <Newsletter /> */}
            <GetInTouch />
            <Footer />
        </div>
    )
}

export default InstituteManagement
